import { Platform } from "react-native";
import LinearGradient from "react-native-linear-gradient";

export const AppTheme = {
  colors: {
    btnColor: "#FCDD26",
    white: "#ffffff",
    black: "#000000",
    linearGradient_1: "#FCDE26",
    linearGradient_2: "#FF9500",
    linearGradient_3: "#8772FF",
    linearGradient_4: "#5E48E2",
    linearGradient_5: "#FCB826",
    linearGradient_6: "#F24F14",
    linearGradient_7: "#8671FF",
    linearGradient_8: "#5743CE",
    linearGradient_9: "#624CD9",
    linearGradient_10: "#3217D0",
    linearGradient_11: "#BFEF45",
    linearGradient_12: "#71DA25",
    LinearGradient_13: "#309000",
    red: "#AC0000",
    lightGrey: "#f2f2f2",
    outline: "#624320",
    brown: "#C5724A",
    boardBack: "#3E2987",
    skycolor: "#05BEDA",
    modalcolor: "#F4A26A",
    green: "#2ECC71",
    settingModal: "#F9C517",
    settingTextBack: "#FFD136",
    border: "#FFF8C2",
    greenBorder: "#2A7E05",
    blueBorder: "#5541CC",
    winnerBorder: "#FAD22B",
    winnerBack: "#9D8CFF",
    darkBrown: "#9C390F",
    otherButton: "#8D78FF",
    winnerButton: "#E4AF0040",
    winnerModalBack:"#E8DAC0",
    winnerModalBorder:"#B6A078",
    error:'#FF0000'
  },
  fonts: {
    BUBBLE_BOBBLE: Platform.OS == "ios" ? "BubbleBobble" : "Bubble-Bobble",
    ALEXANDRIA_REGULAR: "Alexandria-Regular",
    ALEXANDRIA_MEDIUM: "Alexandria-Medium",
    ALEXANDRIA_SEMIBOLD: "Alexandria-SemiBold",
    ALEXANDRIA_BOLD: "Alexandria-Bold",
  },
};
